export default __webpack_public_path__ + "static/Trustpilot_Logo_(2022).svg-8d52d08d982fc8e9001171c361ef3b88.png";